export interface Coordinates {
  latitude: number;
  longitude: number;
}

interface Position {
  coords: Coordinates;
}

export class GeolocationService {
  public static getCurrentPosition(): Promise<Coordinates> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position: Position) => {
          resolve(position.coords);
        },
        (e) => {
          reject(e);
        },
        {
          enableHighAccuracy: true,
          maximumAge: 0,
          timeout: 15000,
        }
      );
    });
  }

  public static getGeolocationPermission(): Promise<PermissionState> {
    return new Promise((resolve, reject) => {
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then((result) => {
            resolve(result.state);
          })
          .catch((error) => reject(error));
      } else {
        reject(new Error('Permissions API not supported'));
      }
    });
  }
}
